export default __webpack_public_path__ + "static/media/ico_planning.aa283c39.svg";